import { z } from 'zod';

export const zodArticleSuggestionItemSchema = z.object({
  deliveryCount: z.number().int(),
  itemId: z.number().int(),
  name: z.string().nullish(),
  sellerAssignedId: z.string().nullish(),
  unit: z.string().nullish(),
});

export const zodArticleSuggestionsResponseSchema = z.object({
  data: z.array(zodArticleSuggestionItemSchema),
});
